module.exports = __webpack_public_path__ + "media/assets/community/badge-pamoja-educator-dd150c902310f35b27e47245c4328976979e093d56b861d2c6de5621741fa869.png";